import { FormTextInput } from '@/components/Form';
import { useStores } from '@/store';
import { capitalize } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { Form, FormField, FormGroup } from 'semantic-ui-react';
import style from './onboarding-submission-details.less';

export const OnboardingSubmissionDetailsPersonal = observer(() => {
  const { temporaryEmployeeStore } = useStores();

  const firstName = temporaryEmployeeStore.current?.user?.firstName ?? '';
  const lastName = temporaryEmployeeStore.current?.user?.lastName ?? '';
  const displayName = temporaryEmployeeStore.current?.user?.displayName ?? '';
  const sin = temporaryEmployeeStore.current?.sin ?? '';
  const gender = capitalize(temporaryEmployeeStore.current?.gender ?? '');
  const dateOfBirth = temporaryEmployeeStore.current?.dateOfBirth?.format('YYYY-MM-DD') ?? '';

  return (
    <Form className={style.form_container}>
      <FormGroup inline className={style.form_group}>
        <FormField width={10}>
          <label htmlFor="firstName" className={style.form_label}>
            LEGAL NAME
          </label>
          <FormTextInput id="firstName" name="First Name" value={firstName} copyable />
        </FormField>
        <FormField width={8}>
          <FormTextInput id="lastName" name="Last Name" value={lastName} copyable />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={16}>
          <label htmlFor="fullName" className={style.form_label}>
            PRINT NAME AS
          </label>
          <FormTextInput id="displayName" name="Display Name" value={displayName} copyable />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={16}>
          <label htmlFor="sin" className={style.form_label}>
            SIN
          </label>
          <FormTextInput id="sin" name="SIN" value={sin} copyable />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={16}>
          <label htmlFor="gender" className={style.form_label}>
            GENDER
          </label>
          <FormTextInput id="gender" name="Gender" value={gender} copyable />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={16}>
          <label htmlFor="dateOfBirth" className={style.form_label}>
            DATE OF BIRTH
          </label>
          <FormTextInput id="dateOfBirth" name="Date of Birth" value={dateOfBirth} copyable />
        </FormField>
      </FormGroup>
    </Form>
  );
});
